module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "generationWebSiteLink"
  }, [_c('el-breadcrumb', {
    staticClass: "bread-nav",
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', [_vm._v("首页")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("天天赢球")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("链接生成器")])], 1), _vm._v(" "), _c('el-form', {
    ref: "form",
    staticClass: "generationLink",
    attrs: {
      "inline": true,
      "model": _vm.form,
      "rules": _vm.validateRules,
      "align": "left"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "链接",
      "prop": "redirectUrl"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "第三方链接地址"
    },
    model: {
      value: (_vm.form.redirectUrl),
      callback: function($$v) {
        _vm.form.redirectUrl = $$v
      },
      expression: "form.redirectUrl"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.generationLink('form')
      }
    }
  }, [_vm._v("生成链接")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.cancal
    }
  }, [_vm._v("取消")])], 1)], 1), _vm._v(" "), (_vm.form.linkUrl) ? _c('div', {
    staticClass: "output-box",
    domProps: {
      "textContent": _vm._s(_vm.form.linkUrl)
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-f6e43536"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/ttyq/LinkGenerate.vue
// module id = 800
// module chunks = 1